// src/aws-config.js
// Values populated from CloudFormation stack outputs.
// In production these come from environment variables set at build time.

const awsConfig = {
  Auth: {
    Cognito: {
      userPoolId:       process.env.REACT_APP_USER_POOL_ID       || "eu-central-1_XXXXXXXXX",
      userPoolClientId: process.env.REACT_APP_USER_POOL_CLIENT_ID || "XXXXXXXXXXXXXXXXXXXXXXXXXX",
      loginWith: {
        email: true,
      },
    },
  },
};

export const API_ENDPOINT = process.env.REACT_APP_API_ENDPOINT || "https://g6fw4rjkvb.execute-api.eu-central-1.amazonaws.com/prototype";

export default awsConfig;
